import { debounceTime } from 'rxjs';

export const debounce = debounceTime(300);
